export default __webpack_public_path__ + "static/media/keto_bad_fats@2x.5c60175c.jpg";